import type { Financial } from "epsm-api-types/models";

export interface FinancialWithPeriod extends Financial {
	period: string;
}

export type TreeColumns = {
	fieldName: string;
	[key: string]: any;
};

export type TableCell = {
	value: number | null;
	options?: Intl.NumberFormatOptions;
	fncClassName?: (value?: number | null) => string;
};

export type Node = {
	field?: string;
	name: string;
	options?: Intl.NumberFormatOptions;
	children?: Node[];
	fncClassName?: (value?: number | null) => string;
};

export type FiscalPeriod = "FY" | "QTR" | "TTM";

export interface FinancialsState {
	ticker?: string;
	fiscalPeriod?: FiscalPeriod;
	color?: string;
}

export enum CompanyTemplate {
	Indu = "indu",
	Fin = "fin",
}
